// ══════════════════════════════════════════════
//  自定义售卖 - Mock 数据
//  TODO: 联调时替换为接口数据
//  价格单位：分
// ══════════════════════════════════════════════

export const SALE_APPS = [
    { appId: 'app1', appName: 'HomeStar' },
    { appId: 'app2', appName: 'SmartHome Pro' },
    { appId: 'app3', appName: 'CloudCam' },
];

// 上架 App 复选树：一级 = App 名称，二级 = 系统-区域
export const APP_SYSTEM_REGIONS = [
    { platform: 'Android', region: '中国大陆' },
    { platform: 'iOS', region: '中国大陆' },
    { platform: 'Android', region: '海外' },
    { platform: 'iOS', region: '海外' },
];

export const SALE_APP_TREE = SALE_APPS.map((app) => ({
    appId: app.appId,
    appName: app.appName,
    children: APP_SYSTEM_REGIONS.map((r) => ({
        id: `${app.appId}::${r.platform}-${r.region}`,
        label: `${r.platform}-${r.region}`,
    })),
}));

// 转为 TreeSelect 数据（一级 App，二级 系统-区域）
export const buildAppTreeSelectData = () => SALE_APP_TREE.map((app) => ({
    value: app.appId,
    title: app.appName,
    key: app.appId,
    children: app.children.map((c) => ({ value: c.id, title: c.label, key: c.id })),
}));

// 解析选中 key → { appName, region }
export const appKeyLabel = (key) => {
    for (const app of SALE_APP_TREE) {
        if (key === app.appId) return { appName: app.appName, region: null };
        const child = app.children.find((c) => c.id === key);
        if (child) return { appName: app.appName, region: child.label };
    }
    return null;
};

// 按 App 聚合选中 key，便于标签展示
export const groupAppKeys = (keys = []) => {
    const map = new Map();
    keys.forEach((key) => {
        const info = appKeyLabel(key);
        if (!info) return;
        if (!map.has(info.appName)) map.set(info.appName, []);
        if (info.region) map.get(info.appName).push(info.region);
    });
    return Array.from(map.entries()).map(([appName, regions]) => ({ appName, regions }));
};

// 平台视角可切换的企业（企业视角固定为登录企业）
export const MOCK_SCOPE_ENTERPRISES = [
    { id: 'ENT001', name: '深圳智创科技有限公司' },
    { id: 'ENT002', name: '杭州万物互联有限公司' },
];

export const CURRENT_ENTERPRISE_ID = 'ENT001';

export const REGION_OPTIONS = [
    { label: '国内', value: '1' },
    { label: '海外', value: '2' },
];

// 企业可售套餐（只读来源《套餐配置》；价格单位：分）
export const SALE_PACKAGES = [
    {
        packageId: 'PKG2024003', name: '事件录像7天', applicationDirection: 1,
        isFree: 0, isSubscription: 1, isNoSubscription: 0,
        salePriceCny: 690, noSubscriptionPriceCny: null,
        subscriptionRegionPricing: { defaultUsd: 95, countryOverrides: [{ country: 'US', usdPrice: 120 }, { country: 'GB', usdPrice: 90 }] },
        noSubscriptionRegionPricing: null,
        platformCostCny: 250, platformCostUsd: 35,
    },
    {
        packageId: 'PKG2024010', name: '国内专享-标清云存', applicationDirection: 2,
        isFree: 0, isSubscription: 1, isNoSubscription: 1,
        salePriceCny: 9900, noSubscriptionPriceCny: 12900,
        subscriptionRegionPricing: null, noSubscriptionRegionPricing: null,
        platformCostCny: 1500, platformCostUsd: null,
    },
    {
        packageId: 'PKG2024011', name: 'Overseas-Pro', applicationDirection: 1,
        isFree: 0, isSubscription: 1, isNoSubscription: 0,
        salePriceCny: null, noSubscriptionPriceCny: null,
        subscriptionRegionPricing: { defaultUsd: 1299, countryOverrides: [{ country: 'US', usdPrice: 1499 }] },
        noSubscriptionRegionPricing: null,
        platformCostCny: null, platformCostUsd: 350,
    },
    {
        packageId: 'PKG2024015', name: '新用户免费体验包', applicationDirection: 2,
        isFree: 1, isSubscription: 0, isNoSubscription: 0,
        salePriceCny: null, noSubscriptionPriceCny: null,
        subscriptionRegionPricing: null, noSubscriptionRegionPricing: null,
        platformCostCny: 200, platformCostUsd: 30,
    },
    {
        packageId: 'PKG2024020', name: 'AI智能检测月卡', applicationDirection: 1,
        isFree: 0, isSubscription: 1, isNoSubscription: 0,
        salePriceCny: 1990, noSubscriptionPriceCny: null,
        subscriptionRegionPricing: null, noSubscriptionRegionPricing: null,
        platformCostCny: 500, platformCostUsd: 80,
    },
    {
        packageId: 'PKG2024025', name: '全家桶年度套餐', applicationDirection: 2,
        isFree: 0, isSubscription: 0, isNoSubscription: 1,
        salePriceCny: null, noSubscriptionPriceCny: 19900,
        subscriptionRegionPricing: null,
        noSubscriptionRegionPricing: { defaultUsd: 2999, countryOverrides: [{ country: 'JP', usdPrice: 3200 }] },
        platformCostCny: 3000, platformCostUsd: 450,
    },
    {
        packageId: 'PKG2024030', name: '逗留提醒服务', applicationDirection: 1,
        isFree: 0, isSubscription: 1, isNoSubscription: 0,
        salePriceCny: 1290, noSubscriptionPriceCny: null,
        subscriptionRegionPricing: { defaultUsd: 179, countryOverrides: [] },
        noSubscriptionRegionPricing: null,
        platformCostCny: 300, platformCostUsd: 45,
    },
    {
        packageId: 'PKG2024031', name: '人脸识别年卡', applicationDirection: 2,
        isFree: 0, isSubscription: 1, isNoSubscription: 0,
        salePriceCny: 3990, noSubscriptionPriceCny: null,
        subscriptionRegionPricing: { defaultUsd: 559, countryOverrides: [{ country: 'US', usdPrice: 599 }] },
        noSubscriptionRegionPricing: null,
        platformCostCny: 800, platformCostUsd: 120,
    },
];

// 功能入口 + 分类树 + 已配置套餐（按企业隔离）
export const INIT_SALE_DATA = {
    ENT001: {
        entries: [
            {
                id: 'SE001', name: '首页商城', code: 'home_mall', sort: 1,
                categories: [
                    {
                        id: 'c1', name: '云存储', code: 'cloud_storage',
                        children: [
                            {
                                id: 'c1-1', name: '全天云存', code: 'full_day',
                                children: [
                                    { id: 'c1-1-1', name: '高清', code: 'full_day_hd' },
                                    { id: 'c1-1-2', name: '标清', code: 'full_day_sd' },
                                ],
                            },
                            { id: 'c1-2', name: '事件云存', code: 'event_cloud' },
                        ],
                    },
                    {
                        id: 'c2', name: 'AI服务', code: 'ai_service',
                        children: [
                            { id: 'c2-1', name: '人脸识别', code: 'face' },
                        ],
                    },
                    { id: 'c3', name: '组合套餐', code: 'combo' },
                ],
                packages: [
                    { id: 'sp1', packageId: 'PKG2024003', categoryId: 'c1-1-1', upApps: ['app1::Android-中国大陆', 'app2::iOS-海外'], domestic: true, overseas: false },
                    { id: 'sp2', packageId: 'PKG2024010', categoryId: 'c1-1-2', upApps: ['app1::iOS-中国大陆'], domestic: true, overseas: false },
                    { id: 'sp3', packageId: 'PKG2024020', categoryId: 'c2-1', upApps: ['app1::Android-中国大陆', 'app1::Android-海外'], domestic: true, overseas: true },
                    { id: 'sp4', packageId: 'PKG2024025', categoryId: 'c3', upApps: ['app1::iOS-中国大陆', 'app3::Android-海外'], domestic: true, overseas: true },
                    { id: 'sp5', packageId: 'PKG2024030', categoryId: null, upApps: ['app2::Android-海外'], domestic: true, overseas: false },
                ],
            },
            {
                id: 'SE002', name: '推荐位弹窗', code: 'rec_popup', sort: 2,
                categories: [
                    { id: 'c10', name: '热门推荐', code: 'hot' },
                    { id: 'c11', name: '新品尝鲜', code: 'new_arrival' },
                ],
                packages: [
                    { id: 'sp6', packageId: 'PKG2024031', categoryId: 'c10', upApps: ['app1::Android-中国大陆'], domestic: true, overseas: true },
                ],
            },
            {
                id: 'SE003', name: '会员中心', code: 'member_center', sort: 3,
                categories: [],
                packages: [],
            },
        ],
    },
    ENT002: {
        entries: [
            {
                id: 'SE101', name: '海外商城', code: 'overseas_mall', sort: 1,
                categories: [
                    { id: 'c20', name: '订阅专区', code: 'subscription' },
                ],
                packages: [
                    { id: 'sp101', packageId: 'PKG2024011', categoryId: 'c20', upApps: ['app1::iOS-海外'], domestic: false, overseas: true },
                ],
            },
        ],
    },
};
